module.exports = __webpack_public_path__ + "img/reason-img.a5117541.png";